module.exports = "https://static.cdns.space/tarot-temp/img/wheel-of-fortune.80f4baa4.webp";